// Don't allow labeling of anomalies that end between now and LABELING_DEAD_ZONE_MINUTES
// At least 10 minutes of non-anomalous time needs to be between now and the anomaly you want to label.
export const LABELING_DEAD_ZONE_MINUTES = 10;

// Disable labeling when the interval is greater than LABELING_ZOOM_OUT_THRESHOLD
export const LABELING_ZOOM_OUT_THRESHOLD = 600;
